import { UIVLIController } from './UIVLIController.ts';
import { UIInternalVideoAdController } from './UIInternalVideoAdController.ts';
import { getMatchmakingVideoAdType } from '../matchmaking/MatchmakingUtilsClient.ts';
import { SocketMatchmakingSend } from '../socket/SocketMatchmakingSend.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
export class UIVideoAdController {
    triggerMatchmakingVideoAd(selectedMatchType, rankedStates, adblockIsActive, matchmakingRequest) {
        const videoAdType = getMatchmakingVideoAdType(selectedMatchType, rankedStates, adblockIsActive);
        if (videoAdType == undefined) return false;
        SocketMatchmakingSend.storeMatchmakingRequest(matchmakingRequest);
        if (videoAdType == 'vli') {
            var _this_vliController;
            (_this_vliController = this.vliController) === null || _this_vliController === void 0 ? void 0 : _this_vliController.startMatchmakingVideoAd();
            return true;
        }
        if (videoAdType != 'internal') return false;
        void UIInternalVideoAdController.start(selectedMatchType);
        return true;
    }
    constructor(){
        this.vliController = UIUtilsEjsVariables.isUserOnDiscord ? undefined : new UIVLIController();
    }
}
